<template>
  <div>
    <z-centralized-toolbar>
        <v-btn depressed rounded color="primary" @click="adicionar">
          <v-icon left>mdi-plus</v-icon>
          Adicionar
        </v-btn>
        <v-btn text icon @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn text rounded color="primary" @click="alternarFiltroPersonalizado">
          <v-icon left>{{ exibirFiltroPersonalizado ? 'mdi-calendar-month' : 'mdi-filter' }}</v-icon>
          {{ exibirFiltroPersonalizado ? 'Filtro mensal' : 'Filtrar' }}
        </v-btn>
        <z-date-navigation v-if="!exibirFiltroPersonalizado" v-model="mesAnoSelecionado" />
    </z-centralized-toolbar>

    <v-divider />

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>
        <z-cabecalho>{{ $store.state.titulo_tela }}</z-cabecalho>

        <v-row class="mb-1">
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="d-flex align-center">
                <v-icon color="red" size="40" class="mr-4">mdi-clock-alert-outline</v-icon>
                <div>
                  <div class="text-caption text-uppercase text--secondary">{{ tipo === 'pagar' ? 'Contas a pagar' : 'Contas a receber' }}</div>
                  <div class="text-h5 font-weight-bold">R$ {{ resumo.contas_pagar | valorBR }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="d-flex align-center">
                <v-icon color="green" size="40" class="mr-4">mdi-check-circle-outline</v-icon>
                <div>
                  <div class="text-caption text-uppercase text--secondary">{{ tipo === 'pagar' ? 'Contas pagas' : 'Contas recebidas' }}</div>
                  <div class="text-h5 font-weight-bold">R$ {{ resumo.contas_pagas | valorBR }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="d-flex align-center">
                <v-icon color="blue" size="40" class="mr-4">mdi-cash</v-icon>
                <div>
                  <div class="text-caption text-uppercase text--secondary">{{ tipo === 'pagar' ? 'Total das contas' : 'Total a receber' }}</div>
                  <div class="text-h5 font-weight-bold">R$ {{ resumo.valor_total | valorBR }}</div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-card v-if="exibirFiltroPersonalizado" class="mb-4">
          <v-toolbar flat color="white" dense>
            <h3 class="text-subtitle-2">Filtro</h3>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pb-0">
            <v-row dense>
              <v-col cols="12" sm="3">
                <z-select label="Data" :items="filtroPeriodoOpcoes" item-text="text" item-value="value" v-model="filtroPeriodo" />
              </v-col>
              <v-col cols="12" sm="3">
                <z-select label="Status" :items="statusOpcoes" item-text="text" item-value="value" v-model="filtroPersonalizado.status" clearable />
              </v-col>
              <v-col cols="12" sm="3">
                <z-select label="Categoria" :items="categorias" item-text="nome" item-value="id" v-model="filtroPersonalizado.categoria_id" clearable />
              </v-col>
              <v-col cols="12" sm="3">
                <z-select label="Conta financeira" :items="contasFinanceiras" item-text="nome" item-value="id" v-model="filtroPersonalizado.conta_financeira_id" clearable />
              </v-col>
            </v-row>

            <v-row v-if="filtroPeriodo === 'intervalo_personalizado'" dense>
              <v-col cols="12" sm="3">
                <z-date-picker-menu left label="Data inicial" v-model="filtroPersonalizado.data_inicio" />
              </v-col>
              <v-col cols="12" sm="3">
                <z-date-picker-menu left label="Data final" v-model="filtroPersonalizado.data_fim" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="primary" @click="limparFiltroPersonalizado">Limpar filtro</v-btn>
            <v-btn color="primary" @click="aplicarFiltroPersonalizado">Aplicar filtro</v-btn>
          </v-card-actions>
        </v-card>

        <v-card>
          <v-data-table
            mobile-breakpoint="0"
            :options.sync="paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headersExibidos"
            :items="lancamentos"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center">
                  <v-chip small dark :color="getStatusColor(item.status)">
                    {{ getStatusText(item.status) }}
                  </v-chip>
                </td>
                <td>{{ item.data_vencimento | dataBR }}</td>
                <td>{{ item.data_hora_quitacao | dataBR }}</td>
                <td>
                  {{ item.descricao }}
                  <span v-if="item.parcela_numero && item.parcela_total">({{ item.parcela_numero }}/{{ item.parcela_total }})</span>
                </td>
                <td class="text-no-wrap">{{ item.categoria ? item.categoria.nome : '-' }}</td>
                <td>{{ item.conta_financeira ? item.conta_financeira.nome : '-' }}</td>
                <td class="text-right font-weight-bold">{{ item.valor | valorBR }}</td>
                <td v-if="tipo === 'receber'" class="text-right font-weight-bold">{{ item.saldo_restante | valorBR }}</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)">
                    <v-icon>{{ item.status === 'quitado' ? 'mdi-eye' : 'mdi-pencil' }}</v-icon>
                  </v-btn>
                  <v-btn v-if="tipo === 'receber'" icon @click="abrirPagamentos(item)"><v-icon>mdi-cash-check</v-icon></v-btn>
                  <v-btn v-else icon @click="marcarQuitado(item)" :disabled="item.status === 'quitado'"><v-icon>mdi-check-circle</v-icon></v-btn>
                  <v-btn v-if="tipo === 'pagar'" icon @click="estornarItem(item)" :disabled="item.status === 'pendente'"><v-icon>mdi-undo</v-icon></v-btn>
                  <v-btn icon @click="excluirItem(item)" :disabled="tipo === 'receber' && item.pagamentos_count > 0"><v-icon>mdi-delete</v-icon></v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </z-container>
    </z-scroll-layout>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="980px" :titulo="tituloDialogo" dividers persistent @abrir="$refs.formulario.resetValidation()">
        <template v-slot:conteudo>
          <v-row dense>
            <v-col cols="12" sm="9">
              <z-text-field v-model="lancamento.descricao" label="Descrição" placeholder=" " :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="3">
              <z-campo-valor v-model="lancamento.valor" label="Valor" placeholder=" " :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="4">
              <z-date-picker-menu left label="Data vencimento" v-model="lancamento.data_vencimento" :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="4">
              <z-select
                label="Categoria"
                :items="categoriasFiltradas"
                item-text="nome"
                item-value="id"
                v-model="lancamento.categoria_id"
                :rules="[regras.campoObrigatorio]"
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <z-select
                label="Conta financeira"
                :items="contasFinanceiras"
                item-text="nome"
                item-value="id"
                v-model="lancamento.conta_financeira_id"
                :rules="[regras.campoObrigatorio]"
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>

            <v-col cols="12" :sm="lancamento.id ? 12 : lancamento.origem === 'unico' ? 6 : 3">
              <z-select
                label="Forma de pagamento"
                :items="$globals.FORMAS_DE_PAGAMENTO"
                item-text="text"
                item-value="value"
                v-model="lancamento.forma_pagamento"
                :disabled="visualizandoLancamentoQuitado"
              />
            </v-col>
            <v-col v-if="!lancamento.id" cols="12" :sm="lancamento.origem === 'unico' ? 6 : 3">
              <z-select label="Parcelado" :items="origemOpcoes" item-text="text" item-value="value" v-model="lancamento.origem" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col v-if="!lancamento.id && lancamento.origem !== 'unico'" cols="12" sm="3">
              <z-text-field type="number" v-model="lancamento.quantidade" label="Quantidade" placeholder=" " :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col v-if="!lancamento.id && lancamento.origem !== 'unico'" cols="12" sm="3">
              <z-select label="Periodicidade" :items="periodicidadeOpcoes" item-text="text" item-value="value" v-model="lancamento.periodicidade" :rules="[regras.campoObrigatorio]" :disabled="visualizandoLancamentoQuitado" />
            </v-col>
            <v-col cols="12" sm="12">
              <z-textarea v-model="lancamento.observacao" label="Observação" placeholder=" " :disabled="visualizandoLancamentoQuitado" />
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">{{ visualizandoLancamentoQuitado ? 'Fechar' : 'Cancelar' }}</v-btn>
          <v-btn v-if="!visualizandoLancamentoQuitado" color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
        </template>
      </z-dialogo>
    </v-form>

    <v-form ref="formularioPagamento" v-model="pagamentoFormValido" lazy-validation>
      <z-dialogo ref="dialogoPagamentos" largura="820px" titulo="Recebimentos" dividers persistent>
        <template v-slot:conteudo>
          <div class="text-subtitle-1 font-weight-bold mb-3">
            {{ recebimentoSelecionado ? recebimentoSelecionado.descricao : '' }}
            <span v-if="recebimentoSelecionado && recebimentoSelecionado.parcela_numero && recebimentoSelecionado.parcela_total">
              ({{ recebimentoSelecionado.parcela_numero }}/{{ recebimentoSelecionado.parcela_total }})
            </span>
          </div>

          <v-row dense class="mb-3">
            <v-col cols="12" sm="4">
              <v-card outlined class="pa-3">
                <div class="text-caption text-uppercase text--secondary">Valor da conta</div>
                <div class="text-h6">R$ {{ (recebimentoSelecionado ? recebimentoSelecionado.valor : 0) | valorBR }}</div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card outlined class="pa-3">
                <div class="text-caption text-uppercase text--secondary">Total recebido</div>
                <div class="text-h6 green--text">R$ {{ resumoPagamentos.total_pago | valorBR }}</div>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card outlined class="pa-3">
                <div class="text-caption text-uppercase text--secondary">Saldo restante</div>
                <div class="text-h6 red--text">R$ {{ resumoPagamentos.saldo_restante | valorBR }}</div>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense align="center">
            <v-col cols="12" sm="4">
              <z-date-picker-menu left label="Data do pagamento" v-model="novoPagamento.data_pagamento" :rules="[regras.campoObrigatorio]" />
            </v-col>
            <v-col cols="12" sm="4">
              <z-campo-valor v-model="novoPagamento.valor" label="Valor pago" placeholder=" " :rules="[regras.campoObrigatorio, validarValorPagamento]" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-btn block color="primary" :loading="salvandoPagamento" :disabled="!pagamentoFormValido || resumoPagamentos.saldo_restante <= 0" @click="adicionarPagamento">
                <v-icon left>mdi-plus</v-icon>
                Lançar pagamento
              </v-btn>
            </v-col>
          </v-row>

          <v-simple-table class="mt-3">
            <thead>
              <tr>
                <th>Data do pagamento</th>
                <th class="text-right">Valor pago</th>
                <th class="text-center" style="width: 80px">Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pagamento in pagamentos" :key="pagamento.id">
                <td>{{ pagamento.data_pagamento | dataBR }}</td>
                <td class="text-right font-weight-bold">R$ {{ pagamento.valor | valorBR }}</td>
                <td class="text-center">
                  <v-btn icon color="red" @click="excluirPagamento(pagamento)"><v-icon>mdi-delete</v-icon></v-btn>
                </td>
              </tr>
              <tr v-if="!pagamentos.length">
                <td colspan="3" class="text-center text--secondary py-4">Nenhum pagamento lançado.</td>
              </tr>
            </tbody>
          </v-simple-table>
        </template>

        <template v-slot:actions_right>
          <v-btn text @click="$refs.dialogoPagamentos.fechar()">Fechar</v-btn>
        </template>
      </z-dialogo>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import * as regras from '@/app/helpers/validacoes';
import categoriasApi from '@/app/services/financeiro/categorias';
import contasApi from '@/app/services/financeiro/contasfinanceiras';
import lancamentosApi from '@/app/services/financeiro/lancamentos';

export default {
  name: 'LancamentosListaBase',
  inject: ['notifications'],
  props: {
    tipo: {
      type: String,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
  },
  data() {
    const hoje = new Date();

    return {
      mesAnoSelecionado: `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`,
      exibirFiltroPersonalizado: false,
      filtroPersonalizado: {
        status: null,
        categoria_id: null,
        conta_financeira_id: null,
        data_inicio: null,
        data_fim: null,
      },
      headers: [
        { text: 'Status', value: 'status', width: '110px', align: 'center' },
        { text: 'Vencimento', value: 'data_vencimento', width: '130px' },
        { text: 'Quitação', value: 'data_hora_quitacao', width: '180px' },
        { text: 'Descrição', value: 'descricao' },
        { text: 'Categoria', value: 'categoria.nome', class: 'text-no-wrap' },
        { text: 'Conta', value: 'conta_financeira.nome' },
        { text: 'Valor', value: 'valor', width: '120px', align: 'right' },
        { text: 'Saldo restante', value: 'saldo_restante', width: '140px', align: 'right', apenasReceber: true },
        { text: 'Opções', value: '', width: '190px', align: 'center', sortable: false },
      ],
      categorias: [],
      contasFinanceiras: [],
      salvando: false,
      salvandoPagamento: false,
      form_valido: true,
      pagamentoFormValido: true,
      recebimentoSelecionado: null,
      pagamentos: [],
      resumoPagamentos: {
        total_pago: 0,
        saldo_restante: 0,
      },
      novoPagamento: {
        data_pagamento: null,
        valor: null,
      },
      regras: { ...regras },
      statusOpcoes: [
        { text: 'Pendente', value: 'pendente' },
        { text: 'Quitado', value: 'quitado' },
      ],
      origemOpcoes: [
        { text: 'Pagamento Único', value: 'unico' },
        { text: 'Dividir', value: 'parcelado' },
        { text: 'Repetir', value: 'recorrente' },
      ],
      periodicidadeOpcoes: [
        { text: 'Diário', value: 'diario' },
        { text: 'Semanal', value: 'semanal' },
        { text: 'Mensal', value: 'mensal' },
        { text: 'Anual', value: 'anual' },
      ],
      filtroPeriodo: 'mes_atual',
      filtroPeriodoOpcoes: [
        { text: 'Hoje', value: 'hoje' },
        { text: 'Próximos 7 dias', value: 'proximos_7_dias' },
        { text: 'Mês atual', value: 'mes_atual' },
        { text: 'Próximo mês', value: 'proximo_mes' },
        { text: 'Próximos 3 meses', value: 'proximos_3_meses' },
        { text: 'Intervalo personalizado', value: 'intervalo_personalizado' },
      ],
    };
  },
  computed: {
    ...mapState('lancamentosfinanceiros', ['lancamento', 'lancamentos', 'total_itens', 'resumo']),
    headersExibidos() {
      return this.headers.filter((header) => !header.apenasReceber || this.tipo === 'receber');
    },
    tituloDialogo() {
      return this.tipo === 'pagar' ? 'Conta a Pagar' : 'Conta a Receber';
    },
    categoriasFiltradas() {
      return this.categorias.filter((item) => item.tipo_aplicacao === 'ambos' || item.tipo_aplicacao === this.tipo);
    },
    visualizandoLancamentoQuitado() {
      return !!this.lancamento.id && this.lancamento.status === 'quitado';
    },
    paginacao: {
      get() {
        return this.$store.state.lancamentosfinanceiros.paginacao;
      },
      set(value) {
        this.$store.commit('lancamentosfinanceiros/UPDATE_PAGINACAO', value);
      },
    },
  },
  async created() {
    this.$store.commit('lancamentosfinanceiros/SET_TIPO', this.tipo);
    this.definirFiltroMes(this.mesAnoSelecionado);
    await Promise.all([this.carregarAuxiliares(), this.refresh()]);
  },
  mounted() {
    this.setTitulo(this.titulo);
  },
  methods: {
    ...mapMutations(['setTitulo']),
    ...mapActions('lancamentosfinanceiros', ['listar', 'abrir', 'salvar', 'atualizar', 'excluir', 'quitar', 'estornar']),
    getStatusText(status) {
      const statusEncontrado = this.statusOpcoes.find((item) => item.value === status);
      return statusEncontrado ? statusEncontrado.text : status;
    },
    getStatusColor(status) {
      if (status === 'quitado') {
        return 'green';
      }

      if (status === 'pendente') {
        return 'red';
      }

      return 'grey';
    },
    definirFiltros(filtros) {
      Object.keys(filtros).forEach((campo) => {
        this.$store.commit('lancamentosfinanceiros/SET_FILTRO', { campo, valor: filtros[campo] });
      });
    },
    obterIntervaloMes(mesAno) {
      const [ano, mes] = mesAno.split('-').map(Number);
      const ultimoDia = new Date(ano, mes, 0).getDate();
      const mesFormatado = String(mes).padStart(2, '0');

      return {
        data_inicio: `${ano}-${mesFormatado}-01`,
        data_fim: `${ano}-${mesFormatado}-${String(ultimoDia).padStart(2, '0')}`,
      };
    },
    formatarDataISO(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      const dia = String(data.getDate()).padStart(2, '0');
      return `${ano}-${mes}-${dia}`;
    },
    definirFiltroPeriodo(periodo) {
      if (periodo === 'intervalo_personalizado') {
        return;
      }

      const hoje = new Date();
      let inicio = new Date(hoje);
      let fim = new Date(hoje);

      if (periodo === 'proximos_7_dias') {
        fim.setDate(fim.getDate() + 7);
      } else if (periodo === 'mes_atual') {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      } else if (periodo === 'proximo_mes') {
        inicio = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 1);
        fim = new Date(hoje.getFullYear(), hoje.getMonth() + 2, 0);
      } else if (periodo === 'proximos_3_meses') {
        fim.setMonth(fim.getMonth() + 3);
      }

      this.filtroPersonalizado.data_inicio = this.formatarDataISO(inicio);
      this.filtroPersonalizado.data_fim = this.formatarDataISO(fim);
    },
    definirFiltroMes(mesAno) {
      const intervalo = this.obterIntervaloMes(mesAno);

      this.filtroPersonalizado.data_inicio = intervalo.data_inicio;
      this.filtroPersonalizado.data_fim = intervalo.data_fim;

      this.definirFiltros({
        status: null,
        categoria_id: null,
        conta_financeira_id: null,
        ...intervalo,
      });
    },
    async alternarFiltroPersonalizado() {
      this.exibirFiltroPersonalizado = !this.exibirFiltroPersonalizado;

      if (this.exibirFiltroPersonalizado) {
        this.definirFiltroPeriodo(this.filtroPeriodo);
      } else {
        this.definirFiltroMes(this.mesAnoSelecionado);
        this.$store.commit('lancamentosfinanceiros/SET_PAGE', 1);
        await this.refresh();
      }
    },
    async aplicarFiltroPersonalizado() {
      this.definirFiltros(this.filtroPersonalizado);
      this.$store.commit('lancamentosfinanceiros/SET_PAGE', 1);
      await this.refresh();
    },
    async limparFiltroPersonalizado() {
      this.filtroPeriodo = 'mes_atual';
      const intervalo = this.obterIntervaloMes(this.mesAnoSelecionado);
      this.filtroPersonalizado = {
        status: null,
        categoria_id: null,
        conta_financeira_id: null,
        ...intervalo,
      };
      this.exibirFiltroPersonalizado = false;
      this.definirFiltroMes(this.mesAnoSelecionado);
      this.$store.commit('lancamentosfinanceiros/SET_PAGE', 1);
      await this.refresh();
    },
    async carregarAuxiliares() {
      const [categorias, contas] = await Promise.all([
        categoriasApi.listar({ itemsPerPage: 200 }),
        contasApi.listar({ itemsPerPage: 200 }),
      ]);

      this.categorias = categorias.data || [];
      this.contasFinanceiras = contas.data || [];
    },
    async refresh() {
      this.$store.commit('lancamentosfinanceiros/SET_TIPO', this.tipo);
      await this.listar();
    },
    obterDataAtual() {
      const hoje = new Date();
      const yyyy = hoje.getFullYear();
      const mm = String(hoje.getMonth() + 1).padStart(2, '0');
      const dd = String(hoje.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    validarValorPagamento(valor) {
      if (!valor || Number(valor) <= 0) {
        return 'Informe um valor maior que zero.';
      }

      if (Number(valor) > Number(this.resumoPagamentos.saldo_restante)) {
        return 'O valor não pode ser maior que o saldo restante.';
      }

      return true;
    },
    aplicarResumoPagamentos(dados) {
      this.recebimentoSelecionado = dados.lancamento;
      this.pagamentos = dados.pagamentos || [];
      this.resumoPagamentos = {
        total_pago: dados.total_pago || 0,
        saldo_restante: dados.saldo_restante || 0,
      };
    },
    async abrirPagamentos(item) {
      try {
        const dados = await lancamentosApi.listarPagamentos(item.id);
        this.aplicarResumoPagamentos(dados);
        this.novoPagamento = {
          data_pagamento: this.obterDataAtual(),
          valor: null,
        };
        this.$refs.dialogoPagamentos.abrir();
        this.$nextTick(() => this.$refs.formularioPagamento.resetValidation());
      } catch (error) {
        this.notifications.notificarErro('Não foi possível carregar os recebimentos.', error);
      }
    },
    async adicionarPagamento() {
      if (!this.$refs.formularioPagamento.validate()) {
        return;
      }

      try {
        this.salvandoPagamento = true;
        const dados = await lancamentosApi.adicionarPagamento(this.recebimentoSelecionado.id, this.novoPagamento);
        this.aplicarResumoPagamentos(dados);
        this.novoPagamento = {
          data_pagamento: this.obterDataAtual(),
          valor: null,
        };
        this.$nextTick(() => this.$refs.formularioPagamento.resetValidation());
        this.notifications.notificar('Pagamento lançado com sucesso.');
        await this.refresh();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível lançar o pagamento.', error);
      } finally {
        this.salvandoPagamento = false;
      }
    },
    async excluirPagamento(pagamento) {
      const resposta = await this.notifications.dialogo_pergunta.abrir({
        titulo: 'Remover pagamento?',
        texto: 'O saldo restante da conta será recomposto.',
        botoes: ['Cancelar', 'Remover'],
        padrao: 'Remover',
        cor: 'red',
      });

      if (resposta !== 'Remover') {
        this.notifications.dialogo_pergunta.fechar();
        return;
      }

      try {
        this.notifications.dialogo_pergunta.carregando();
        const dados = await lancamentosApi.excluirPagamento(this.recebimentoSelecionado.id, pagamento.id);
        this.aplicarResumoPagamentos(dados);
        this.notifications.dialogo_pergunta.fechar();
        this.notifications.notificar('Pagamento removido com sucesso.');
        await this.refresh();
      } catch (error) {
        this.notifications.dialogo_pergunta.fechar();
        this.notifications.notificarErro('Não foi possível remover o pagamento.', error);
      }
    },
    adicionar() {
      this.$store.commit('lancamentosfinanceiros/ZERAR');
      const contaPadrao = this.contasFinanceiras.find((conta) => conta.padrao);
      const dataAtual = this.obterDataAtual();
      this.lancamento.data_lancamento = dataAtual;
      this.lancamento.data_vencimento = dataAtual;
      this.lancamento.conta_financeira_id = contaPadrao ? contaPadrao.id : null;

      this.$refs.dialogoAdicionar.abrir();
    },
      formatQuitacao(dataHoraQuitacao) {
        if (!dataHoraQuitacao) {
          return '-';
        }

        const normalizada = String(dataHoraQuitacao).replace(' ', 'T');
        const data = new Date(normalizada);

        if (Number.isNaN(data.getTime())) {
          return dataHoraQuitacao;
        }

        return data.toLocaleString('pt-BR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        });
      },
    async editar(item) {
      await this.abrir(item.id);
      this.$refs.dialogoAdicionar.abrir();
    },
    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return;
      }

      try {
        this.salvando = true;
        this.lancamento.tipo = this.tipo;
        this.lancamento.data_lancamento = this.lancamento.data_lancamento || this.obterDataAtual();

        if (!this.lancamento.id) {
          this.lancamento.status = 'pendente';
        }

        if (this.lancamento.status === 'quitado' && !this.lancamento.data_hora_quitacao) {
          this.lancamento.data_hora_quitacao = new Date().toISOString().slice(0, 19).replace('T', ' ');
        }

        if (this.lancamento.id) {
          await this.atualizar(this.lancamento);
        } else {
          await this.salvar(this.lancamento);
        }

        this.$refs.dialogoAdicionar.fechar();
        this.notifications.notificar('Lançamento salvo com sucesso.');
        await this.refresh();
      } catch (error) {
        this.notifications.notificarErro('Não foi possível salvar o lançamento.', error);
      } finally {
        this.salvando = false;
      }
    },
    async marcarQuitado(item) {
      await this.quitar({ id: item.id, data_hora_quitacao: new Date().toISOString().slice(0, 19).replace('T', ' ') });
      this.notifications.notificar('Lançamento marcado como quitado/recebido.');
      await this.refresh();
    },
    async estornarItem(item) {
      await this.estornar(item.id);
      this.notifications.notificar('Lançamento estornado para pendente.');
      await this.refresh();
    },
    async excluirItem(item) {
      const resposta = await this.notifications.dialogo_pergunta.abrir({
        titulo: 'Remover lançamento?',
        texto: 'O lançamento será removido do sistema.',
        botoes: ['Cancelar', 'Remover'],
        padrao: 'Remover',
        cor: 'red',
      });

      if (resposta === 'Remover') {
        try {
          this.notifications.dialogo_pergunta.carregando();
          await this.excluir(item.id);
          this.notifications.dialogo_pergunta.fechar();
          this.notifications.notificar('Lançamento removido com sucesso.');
          await this.refresh();
        } catch (error) {
          this.notifications.dialogo_pergunta.fechar();
          this.notifications.notificarErro('Não foi possível remover o lançamento.', error);
        }
      } else {
        this.notifications.dialogo_pergunta.fechar();
      }
    },
  },
  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
    mesAnoSelecionado(novoMesAno) {
      if (this.exibirFiltroPersonalizado) {
        return;
      }

      this.definirFiltroMes(novoMesAno);
      this.$store.commit('lancamentosfinanceiros/SET_PAGE', 1);
      this.refresh();
    },
    filtroPeriodo(novoPeriodo) {
      this.definirFiltroPeriodo(novoPeriodo);
    },
    'lancamento.status'(novoStatus) {
      if (novoStatus !== 'quitado') {
        this.lancamento.data_hora_quitacao = null;
      }
    },
    tipo() {
      this.$store.commit('lancamentosfinanceiros/SET_PAGE', 1);
      if (this.exibirFiltroPersonalizado) {
        this.definirFiltros(this.filtroPersonalizado);
      } else {
        this.definirFiltroMes(this.mesAnoSelecionado);
      }
      this.refresh();
    },
  },
};
</script>
